<!--用于用户管理登录注册协议组件-->
<!--使用方式
<agreement
    :info="agreementInfo"
    @getStatus="getStatus"
    :checked="checked"
    class="self-check"
>
</agreement>
agreementInfo:{
agreementNos: [
"information",
"privacy"
]
},-->
<template>
  <div class="check">
    <div
      class="icon-agree"
      v-show="!hideAgreeText"
      :class="{ agree: value }"
      @click="sendStatus"
    ></div>
    <div class="text" v-show="!hideAgreeText">
      <template v-for="(item, index) in infoList">
        <span v-if="typeof item === 'string'" :key="index">{{ item }}</span>
        <!--      :class="item.isRead ? 'text-gray' : 'text-blue'"-->
        <span
          v-else
          @click="clickAgreement(true)"
          class="text-blue"
          :key="index"
          >《{{ item.data.title }}》</span
        >
      </template>
    </div>
    <el-dialog
      :title="BYD.data.title"
      :visible.sync="agreementShow"
      :show-close="true"
      :before-close="handleClose"
      :center="true"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="60%"
      height="80%"
    >
      <!--      <el-dialog-->
      <!--          width="30%"-->
      <!--          title="温馨提示"-->
      <!--          :visible.sync="innerVisible"-->
      <!--          append-to-body>-->
      <!--        您暂未完成协议阅读-->
      <!--      </el-dialog>-->
      <div
        class="content-a"
        ref="content"
        v-if="agreementShow"
        v-html="BYD.data.content"
      ></div>
      <span slot="footer" class="dialog-footer">
        <el-button
          :disabled="!BYD.isRead"
          class="read-btn"
          @click="readAgree(BYD.isRead)"
          >{{ btnText }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "agreement3",
  props: ["checked", "info", "hideAgreeText"],
  data() {
    return {
      agreementShow: false,
      value: false,
      isRead: false,
      BYD: {
        data: {
          title: "",
          content: "",
        },
        isRead: "",
      },
      index: 0,
      infoList: [],
      btnText: "我已阅读并同意",
      lastBtn: "我已阅读并同意",
      defaultBtn: "同意并阅读下一个",
      agreementList: "",
      timer: null,
    };
  },
  computed: {
    isLast() {
      return this.index == this.agreementList.length - 1;
    },
  },
  created() {
    this.init();
  },
  methods: {
    handleClose() {
      clearInterval(this.timer);
      this.agreementShow = false;
    },
    sendStatus() {
      if (this.agreementList.findIndex((item) => item.isRead === false) == -1) {
        this.value = !this.value;
      } else {
        this.clickAgreement(true);
      }
      this.$emit("getStatus", this.value);
    },
    clickAgreement(first) {
      this.agreementShow = true;
      const _this = this;
      if (!first) {
        if (this.isLast) {
          this.agreementShow = false;
          this.value = true;
          this.$emit("getStatus", this.value);
          this.$emit("getVersion", (callback) => {
            if (callback) {
              this.$POST("usr/user/agreement/status/save", this.info)
                .then((res) => {
                  if (res.ret != 0) {
                    this.$message.warning("阅读协议更新失败");
                  }
                })
                .catch((ex) => {
                  this.$message.warning("阅读协议更新失败");
                });
              callback();
            }
          });
          return;
        }
        this.index++;
      } else {
        this.index = 0;
      }
      this.BYD = this.agreementList[this.index];
      if (!this.BYD.isRead) {
        this.startCutDown();
      } else {
        this.btnText = this.isLast ? this.lastBtn : this.defaultBtn;
      }
    },
    readAgree() {
      this.agreementShow = false;
      this.agreementList[this.index].isRead = true;
      setTimeout(() => {
        this.clickAgreement();
      }, 200);
    },
    startCutDown() {
      console.log(
        "num",
        this.index,
        this.agreementList.length - 1,
        this.isLast
      );
      let countDownTime = 10;
      const txt = this.isLast ? this.lastBtn : this.defaultBtn;
      this.btnText = `${txt}(${countDownTime}s)`;
      this.timer = setInterval(() => {
        if (countDownTime > 1) {
          countDownTime -= 1;
          this.btnText = `${txt}(${countDownTime}s)`;
        } else {
          clearInterval(this.timer);
          this.BYD.isRead = true;
          this.btnText = `${txt}`;
        }
      }, 1000);
    },
    async init() {
      const that = this;
      this.value = this.checked;
      this.infoList = [];
      this.agreementList = [];
      this.$POST("usr/publicrs/agreement/query", this.info).then((res) => {
        if (res.ret == 0) {
          res.data.map((item, index) => {
            this.infoList.push({
              data: {
                title: item.agreementName,
                content: item.content,
              },
              enforced: true, // this.value ? false : item.enabled
            });
            if (index !== res.data.length - 1) {
              this.infoList.push("、");
            }
          });
          this.infoList.unshift("我已阅读并同意");
          this.infoList.push("。");
          this.subArray(this.infoList);
        }
      });
    },
    subArray(info) {
      this.agreementList = info.map((item) => {
        if (typeof item === "object") {
          item.isRead = !item.enforced;
          return item;
        }
      });
      for (let i = 0; i < this.agreementList.length; i++) {
        if (typeof this.agreementList[i] === "undefined") {
          this.agreementList.splice(i, 1);
          i = i - 1;
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .content-a {
  font-family: SimSun;
  p {
    line-height: 1.8;
  }
  .title {
    text-align: center;
  }
  .ident {
    text-indent: 28px;
  }
}
/deep/ .el-checkbox__inner {
  margin-right: 2px;
}
/deep/ .el-dialog__body {
  height: 400px;
  overflow: auto;
}
/*/deep/ .el-dialog__footer{*/
/*  text-align: center;*/
/*}*/
.check {
  font-size: 11px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 15px;
  color: #2e2f3c;
  color: #2e2f3c;
  padding-left: 8px;
  margin-top: 15px;
  position: relative;
  .text-blue {
    color: #1b5bbf;
    cursor: pointer;
  }
  .text-gray {
    color: #666666;
    cursor: pointer;
  }
  .icon-agree {
    position: absolute;
    width: 14px;
    height: 14px;
    border: solid 1px #d5dbe8;
    border-radius: 4px;
    left: 0px;
    cursor: pointer;
    &.agree {
      background: url("~@/assets/img/common/icon_read.png");
      background-size: 100% 100%;
      border: none;
    }
  }
  .text {
    margin-left: 18px;
    line-height: 1.2;
  }
}
</style>